import { getStartDate, getEndDate } from '../selectors/getStoreProperties';
import { createDisplayDate } from 'owa-datetime';
import { now } from 'owa-datetime';
/**
 * Utility function to get the new end date based upon start date and current date
 * @returns instance of DisplayDate type
 */
export default function getEndDateAfterModifications() {
    var currentDate = now();
    var startDate = getStartDate();
    var endDate = getEndDate();
    // If start time is more than both current time and end time, new end date is start date + 1
    var firstScenario = startDate > currentDate && startDate > endDate;
    if (firstScenario) {
        return getNextDate(startDate, startDate);
    }
    // If start time is less than current time and end time is less than start time or current time, new end date is current date + 1
    var secondScenario = startDate < currentDate && (endDate < currentDate || endDate < startDate);
    if (secondScenario) {
        return getNextDate(currentDate, startDate);
    }
    // Return the same end date if neither of the condition is true
    return endDate;
}
function getNextDate(date, startDate) {
    return createDisplayDate(date.getFullYear(), date.getMonth(), date.getDate() + 1, startDate.getHours(), startDate.getMinutes());
}
//# sourceMappingURL=getEndDateAfterModifications.js.map